const map = {
  height: '200px',
  width: '100%',
}

export const styles = {
  map,
}
